import React from 'react';
import { withRouter } from 'react-router-dom';
import { OrdersIcon, FlexBox, ClickableBox } from '../Components';
import { routes } from '../routes';

const OrderListButton = withRouter(({ history }) => (
    <ClickableBox onClick={() => history.push(routes.orderList)}>
      <FlexBox>
        <OrdersIcon />
      </FlexBox>
    </ClickableBox>
));

export default OrderListButton;
